import { render } from "./PropostaValet.vue?vue&type=template&id=760b98e3&scoped=true"
import script from "./PropostaValet.vue?vue&type=script&lang=js"
export * from "./PropostaValet.vue?vue&type=script&lang=js"

import "./PropostaValet.vue?vue&type=style&index=0&id=760b98e3&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-760b98e3"]])

export default __exports__